import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import Button from '@material-ui/core/Button';
import Routes from './routes';

import { Map, GoogleApiWrapper } from 'google-maps-react';
// AIzaSyADExq-eX12BxxOxtd3pPW2yfpyCOKTsVU&

const App = () => {
  return (
    <React.Fragment>
      <CssBaseline />
      <Routes />
    </React.Fragment>
  );
}

export  default App;

// export default GoogleApiWrapper({
//   apiKey: 'AIzaSyADExq-eX12BxxOxtd3pPW2yfpyCOKTsVU&'
// })(App)
